import {
  PanelBody,
  ColorPalette,
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";
import { t } from "drupal";

// Color options (name, hex, and associated class)
const backgroundOptions = [
  { name: 'Purple', color: '#32006E', class: 'purple' },
  { name: 'Dark Grey', color: '#404040', class: 'darkgrey' },
  { name: 'Light Grey', color: '#E5E5E5', class: 'litegrey' },
  { name: 'White', color: '#FFFFFF', class: 'white' },
];

function FullWidthContainerSidePanel({
  backgroundColorClass,
  onChangeBackgroundColorClass
}) {
  return (
    <InspectorControls>
      <PanelBody title={t("Instructions")} initialOpen>
        <p>{t("Click the + button to add a block inside the full-width container.")}</p>

        <label className="form-label">{t("Background Color")}</label>
        <ColorPalette
          colors={backgroundOptions}
          value={
            backgroundOptions.find(opt => opt.class === backgroundColorClass)?.color || ''
          }
          onChange={(selectedColor) => {
            const selected = backgroundOptions.find(opt => opt.color === selectedColor);
            if (selected) {
              onChangeBackgroundColorClass(selected.class);
            }
          }}
        />
      </PanelBody>
    </InspectorControls>
  );
}

export default FullWidthContainerSidePanel;
